module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/f721f92d4c2e1627652824af85453a07.png";